export default function SvgIcon({
  width = "24",
  height = "24",
  color = "none",
  minX = 0,
  minY = 0,
  viewBox = null,
  children,
  ...rest
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox || `${minX} ${minY} ${width} ${height}`}
      fill={color}
      {...rest}
    >
      {children}
    </svg>
  );
}